module.exports = __webpack_public_path__ + "static/media/2@3x.b47db0cf.png";